// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListWrapper_wrapper__3DiYS"};